module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush"
  }, [_vm._v("Gathering a group of Lutheran and Reformed theologians to discuss and debate some of the core matters of their shared and respective traditions has been a dream of mine since I learned it was a dream of Thomas Cranmer’s. The essays in this book began as part of a colloquium at the Cathedral Church of the Advent (Birmingham, AL) in July 2016. I am grateful to all who met together for those meaningful and fun few days, and especially to those whose contributions make up the contents of this collection.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The loudest thanks—and here I’m sure all the contributors would agree—must go to the Cathedral Church of the Advent. Their hospitality, financial generosity, and encouragement through their commitment to a ministry of preaching and pastoral care informed by the theology of the Reformation made what was an isolated and unlikely wish into a shared and fruitful reality. The entire parish has our gratitude and affection, and special thanks go to Dean Andrew Pearson and Gil Kracke for their support of and participation in the colloquium.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("I am grateful to Eerdmans for allowing our conversation to be heard publicly by helping to form a colloquial dialogue into the present book.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This book is dedicated to six friends—Lutherans, Anglicans, Reformed—in conversation.")]), _vm._v(" "), _c('p', {
    staticClass: "RightSb1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONATHAN")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INEBAUGH")]), _c('br'), _c('i', [_vm._v("Jesus College, Cambridge")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24f7eb17","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgements.vue
// module id = 69
// module chunks = 0